import HolidayRule from '@/api/hr/holiday-rule'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  substitute: {
    subs_day1: '',
    subs_day2: ''
  }
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  RECEIVE_SUBSTITUTE(state, { subs_day1, subs_day2 }) {
    state.substitute = { subs_day1, subs_day2 }
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: -1,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return HolidayRule.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return HolidayRule.store(data)
  },

  fetchSubstitute(context, attributes = {}) {
    return HolidayRule.getSubstitute().then(response => {
      context.commit('RECEIVE_SUBSTITUTE', response.data)
      return Promise.resolve(response)
    })
  }
}
